import type { ImportBatch, ImportBatchFilter, ImportBatchRepository } from "../../../domain/import/import-batch.js";

/** Persistência do lote de importação — mesmo padrão dos demais repositórios em memória. */
export class InMemoryImportBatchRepository implements ImportBatchRepository {
  private batches = new Map<string, ImportBatch>();

  constructor() {
    try {
      if (typeof localStorage !== "undefined") {
        const raw = localStorage.getItem("inspect_import_batches");
        if (raw) this.batches = new Map(JSON.parse(raw));
      }
    } catch (error) {
      console.warn("Failed to load import batches from localStorage", error);
    }
  }

  private persist(): void {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("inspect_import_batches", JSON.stringify(Array.from(this.batches.entries())));
      }
    } catch (error) {
      console.warn("Failed to persist import batches to localStorage", error);
    }
  }

  async save(batch: ImportBatch): Promise<void> {
    this.batches.set(batch.id, batch);
    this.persist();
  }

  async findById(id: string): Promise<ImportBatch | null> {
    return this.batches.get(id) ?? null;
  }

  async list(filter: ImportBatchFilter = {}): Promise<ImportBatch[]> {
    return [...this.batches.values()]
      .filter(batch => {
        if (filter.clientId && batch.clientId !== filter.clientId) return false;
        if (filter.projectId && batch.projectId !== filter.projectId) return false;
        if (filter.serviceOrderId && batch.serviceOrderId !== filter.serviceOrderId) return false;
        if (filter.sourceHash && batch.sourceHash !== filter.sourceHash) return false;
        if (filter.status && batch.status !== filter.status) return false;
        return true;
      })
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }
}
